import ArticleCover from './ArticleCover';
import ArticleSimple from './ArticleSimple';
import ArticleIntroView from './atoms/ArticleIntroView';
import AuthorIntro from './atoms/AuthorIntro';
import CoverPhoto from './atoms/CoverPhoto';

export { CoverPhoto, ArticleCover, AuthorIntro, ArticleIntroView, ArticleSimple };
